import { Navigate } from 'react-router-dom';
import { getFirstAccessibleRoute } from '../../utils/permissions';

/**
 * SmartRedirect component
 * Redirects user to the first accessible route based on their permissions
 */
function SmartRedirect() {
    const firstAccessibleRoute = getFirstAccessibleRoute();
    return <Navigate to={firstAccessibleRoute} replace />;
}

export default SmartRedirect;
